import { useCallback, useRef, useState } from 'react';
import { useMemo } from 'react';
import { DOCUMENTS } from 'hubspot-prosemirror/prosemirror/editorCapabilities';
import { useReactNodeView } from '../utils/ReactNodeView';
import DocumentPreviewTable from './documentPreview/DocumentPreviewTable';
import { buildDocumentPreviewTr } from '../utils/documentUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentPreviewView = () => {
  var _editorConfig$DOCUMEN;
  const context = useReactNodeView();
  const view = context.view;
  const initialAttrs = useMemo(() => context.node ? context.node.attrs : {}, [context.node]);
  const attrs = useRef(initialAttrs);
  const [previewTitle, setPreviewTitle] = useState(attrs.current.previewTitle);
  const [description, setDescription] = useState(attrs.current.description);
  const [showEditPreview, setShowEditPreview] = useState(false);
  const updatePreview = useCallback(({
    title,
    desc
  }) => {
    if (view) {
      const editorState = view.state;
      const tr = buildDocumentPreviewTr({
        documentId: parseInt(attrs.current.documentId, 10),
        documentName: attrs.current.documentName,
        requireEmail: attrs.current.requireEmail,
        previewTitle: title,
        previewImage: attrs.current.previewImage,
        description: desc,
        linkInfo: {
          url: attrs.current.tokenTag,
          text: attrs.current.tokenTag
        },
        includeLinkPreview: true,
        editorState,
        updateFromView: true
      });
      // adding a delay to ensure the popover closes before the transaction is dispatched
      setTimeout(() => {
        view.dispatch(tr);
      }, 50);
    }
  }, [view]);
  const editorConfig = context.editorConfig;
  const outputType = editorConfig === null || editorConfig === void 0 || (_editorConfig$DOCUMEN = editorConfig[DOCUMENTS]) === null || _editorConfig$DOCUMEN === void 0 ? void 0 : _editorConfig$DOCUMEN.outputType;
  return /*#__PURE__*/_jsx(DocumentPreviewTable, {
    documentId: attrs.current.documentId,
    previewImage: attrs.current.previewImage,
    previewTitle: previewTitle,
    description: description,
    setPreviewTitle: setPreviewTitle,
    setDescription: setDescription,
    documentName: attrs.current.documentName,
    showEditPreview: showEditPreview,
    setShowEditPreview: setShowEditPreview,
    editable: view === null || view === void 0 ? void 0 : view.editable,
    tokenTag: attrs.current.tokenTag,
    outputType: outputType,
    updatePreview: updatePreview
  });
};
export default DocumentPreviewView;
export const documentPreviewViewUpdateFn = ({
  previousNode,
  node
}) => {
  if (previousNode.attrs.documentId !== node.attrs.documentId || previousNode.attrs.previewTitle !== node.attrs.previewTitle || previousNode.attrs.description !== node.attrs.description) {
    return false;
  }
  return true;
};